<p-fieldset>
  <p-header class="article-title">
      <span class="article-title">Faturamento > Gestão de Notas</span>
      <button class="fab-button primary" appFiltersButton pTooltip="Exibir/Ocultar Filtros" tooltipPosition="left">
          <i class="pi pi-filter"></i>
      </button>
  </p-header>
  <app-invoice-tax-dialog></app-invoice-tax-dialog>
</p-fieldset>